import React from 'react';
import styles from './HomePage.module.css';

const HomePage = () => {
  return (
    <div className={styles.homePage}>
      <header className={styles.heroSection}>
        <div className={styles.heroText}>
          <h2 className={styles.heroTitle}>Create your own podcast,</h2>
          <p className={styles.heroSubtitle}>about whatever you want.</p>
        </div>
      </header>
      
      <section className={styles.features}>
        <h2>Features</h2>
        <div className={styles.downArrow}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 10L12 15L17 10" stroke="#2d3748" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <div className={styles.featureGrid}>
          <div className={styles.featureCard}>
            <h3>Create Your Own Podcast</h3>
            <p>Create podcasts about the specific topics you want to learn more about and explore. Even create fictional stories to keep you or your kids entertained. You can literally create a podcast about anything.</p>
          </div>
          <div className={styles.featureCard}>
            <h3>Integrate Your Apps</h3>
            <p>Connect with tools such as Gmail, Google Drive, and others and have podcasts created to keep up with your daily life and tasks. Even create a podcast about your files or inbox.</p>
          </div>
          <div className={styles.featureCard}>
            <h3>Connect With Friends</h3>
            <p>Show off your stuff and share your podcasts with others. Build a community around your content and discover new perspectives through shared listening experiences.</p>
          </div>
        </div>
      </section>
      
      <section className={styles.useCasesSection}>
        <h2>Create a podcast about:</h2>
        <div className={styles.useCasesGrid}>
          <div className={styles.useCaseCard}>
            <div className={styles.useCaseIcon}>📈</div>
            <h3>Your personal stock portfolio</h3>
            <p>Stay informed about your investments with daily updates on your holdings, market trends, and personalized financial insights.</p>
          </div>
          <div className={styles.useCaseCard}>
            <div className={styles.useCaseIcon}>🌅</div>
            <h3>Your morning routine podcast</h3>
            <p>Start your day with a personalized podcast about your upcoming schedule, weather, relevant news, and daily insights.</p>
          </div>
          <div className={styles.useCaseCard}>
            <div className={styles.useCaseIcon}>🔍</div>
            <h3>A investigative story for your kid</h3>
            <p>Create engaging mystery stories and educational content tailored to your child's interests and learning level.</p>
          </div>
          <div className={styles.useCaseCard}>
            <div className={styles.useCaseIcon}>🎨</div>
            <h3>A new hobby you're looking to start</h3>
            <p>Get expert guidance and inspiration as you explore new interests, from cooking to woodworking to photography.</p>
          </div>
          <div className={styles.useCaseCard}>
            <div className={styles.useCaseIcon}>🏘️</div>
            <h3>The small village in Ireland you're visiting</h3>
            <p>Discover the rich history, local culture, and hidden gems of your travel destinations through personalized audio guides.</p>
          </div>
          <div className={styles.useCaseCard}>
            <div className={styles.useCaseIcon}>📚</div>
            <h3>Your favorite book series</h3>
            <p>Dive deeper into the worlds you love with character analysis, plot discussions, and behind-the-scenes insights from your favorite stories.</p>
          </div>
        </div>
      </section>
      
      <section className={styles.qaSection}>
        <h2>Frequently Asked Questions</h2>
        <div className={styles.qaList}>
          <div className={styles.qaItem}>
            <h3>How does this work? How does it create podcasts?</h3>
            <p>Our platform uses advanced AI technology to transform your content into engaging podcast episodes. Simply provide your topics, documents, or data sources, and our system will generate personalized audio content tailored to your interests and learning style.</p>
          </div>
          <div className={styles.qaItem}>
            <h3>Can I create a podcast for other people on Spotify?</h3>
            <p>No, these podcasts are meant for personal use but can be shared with other users on the website. Our platform focuses on creating personalized content for your own learning and entertainment, with the option to share discoveries with friends within our community.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
